const locale = {
	heroTitle: '瑞士型走心式车床精密加工专家',
	heroSubtitle: 'Cincom L20 走心机・φ1–20mm 小径精密件・医疗・连接器・航太',
	heroCtaProducts: '查看产品',
	heroCtaContact: '立即询价',
	featuresTitle: '我们的优势',
	feature1Title: '瑞士型走心机（Cincom L20）',
	feature1Desc:
		'配备 Citizen Cincom L20 瑞士型走心式 CNC 车床，专精直径 φ1–20mm 小型精密零件加工，可稳定达到 ±0.005mm 高精度公差。走心机特别适合细长轴、医疗探针、连接器接脚、航太紧固件等需要高长径比或超高精度的零件。材质涵盖不锈钢、铝合金、铜、钛合金、碳钢及工程塑胶，支持单件打样至批量生产。',
	feature2Title: '全制程整合',
	feature2Desc:
		'擎亿提供从图面设计、工程开发、CNC 走心加工，到后段表面处理的一站式服务，涵盖研磨、抛光、阳极处理、电镀（镀镍、镀铬、镀锌）、喷砂等完整制程。客户只需提供图面或样品，其余交由擎亿全程负责，大幅节省跨厂协调时间，有效缩短整体交期，降低管理成本。',
	feature3Title: 'ISO 9001 认证',
	feature3Desc:
		'擎亿通过 ISO 9001:2015 品质管理体系国际认证，建立标准化的生产作业流程与完整的品质追溯机制。每批产品出货前均进行严格的尺寸量测（三次元 CMM 量测）与外观检验，并保留完整的生产记录与检验报告。持续的制程改善与品管稽核，确保每一件交付品皆符合客户规格与国际品质标准。',
	aboutTitle: '关于擎亿精密',
	about:
		'擎亿精密有限公司创立于台湾新北市，专注于瑞士型走心式 CNC 精密加工，配备 Citizen Cincom L20 走心机，专精 φ1–20mm 小径精密零件制造。服务范围涵盖产品设计、工程开发、技术绘图，以及 CNC 加工后的研磨、抛光、电镀等完整后制程，提供客户一站式的精密制造解决方案。\n\n因应医疗器材、连接器、航太紧固件、电子设备、手表机芯等各产业对小径精密件的需求，擎亿能够根据客户图面或样品进行高精度客制化生产，公差稳定达到 ±0.005mm。凭借 ISO 9001 认证的严谨品管制度，以及持续精进的走心加工技术，我们持续为客户交付尺寸精准、品质稳定、准时到货的精密零件，是您可长期信赖的台湾精密制造伙伴。\n\n在材质应用上，擎亿熟稔不锈钢（SUS）、黄铜、紫铜、铝合金与工程塑胶等多元加工，并可搭配热处理与各式表面处理；从少量打样、试量产到大批量交货，皆维持一致的尺寸精度与表面品质。自进料检验、制程巡检到出货全尺寸检测，每道工序均完整记录可追溯，辅以弹性的产能调度与即时的工程沟通，协助客户缩短开发周期、加速产品上市。我们始终相信「品质源于细节」，以专业与诚信，与每一位客户建立长期稳定的合作关系。',
	isoTitle: 'ISO 9001 质量管理体系验证',
	isoClick: '点击查看证书',
	mineralsTitle: '负责任矿产采购政策',
	mineralsClick: '点击查看政策',
	servicesTitle: '核心服务',
	services: [
		'产品设计',
		'工程开发',
		'技术绘图',
		'CNC 走心加工',
		'研磨',
		'抛光',
		'电镀',
		'CMM 质量检验'
	],
	stats: [
		{ value: 'Cincom L20', label: '瑞士型走心机' },
		{ value: 'φ1–20mm', label: '加工直径范围' },
		{ value: '±0.005mm', label: '稳定公差' },
		{ value: 'ISO 9001', label: '质量认证' }
	],
	milestonesTitle: '发展历程',
	milestonesSubtitle: '持续精进，稳健成长',
	milestones: [
		{
			year: '2021',
			title: '官方网站建置上线',
			desc: '建立繁中／简中／英文三语官方网站，导入在线产品展示与移动设备浏览支援，让国内外客户都能即时了解擎亿的加工能力。'
		},
		{
			year: '2022',
			title: '导入数据化营运',
			desc: '整合 Google Analytics 4，掌握客户来源与浏览行为，持续优化数字营销与服务体验。'
		},
		{
			year: '2024',
			title: '通过 ISO 9001:2015 认证',
			desc: '取得国际质量管理体系验证，建立标准化生产流程与完整质量追溯机制，为客户交付稳定品质。'
		},
		{
			year: '2026',
			title: '网站全面改版',
			desc: '重新设计用户界面与内容，强化 SEO 与品牌形象，完整呈现 Cincom L20 走心机与小径精密件实力。'
		},
		{
			year: '2026',
			title: '发布负责任矿产采购政策',
			desc: '响应 RBA 与 OECD 规范，公开承诺落实供应链无冲突矿产管理，与客户共同善尽企业责任。'
		}
	],
	productsTitle: '精选产品',
	productsSubtitle: 'Cincom L20 走心机精密加工件',
	viewAllProducts: '查看全部产品',
	specsTitle: '设备规格',
	spec2Lbl: '小径精密加工范围',
	spec3Lbl: '精度公差',
	specTblDiameter: '最大加工直径',
	specTblLength: '最大加工长度（单次夹持）',
	specTblSpindle: '主轴转速',
	specTblRotaryTool: '旋转刀具转速',
	specTblTools: '最大刀具数',
	specTblLFV: 'LFV 切屑控制',
	specTblLFVVal: '正反面均支持',
	pageTitle: '擎亿精密有限公司 | 瑞士型走心机 CNC 精密加工',
	pageDesc: '擎亿精密配备 Citizen Cincom L20 瑞士型走心式 CNC 车床，专精 φ1–20mm 小径精密零件，公差 ±0.005mm，ISO 9001:2015 认证，服务医疗、连接器、航太产业。',
	pageKeywords: '瑞士型车床, 走心机, Cincom L20, 精密加工, 小径零件, 医疗零件, 连接器加工, 航太零件, 台湾制造, ISO9001, 擎亿精密, 新北市',
	contactTitle: '联系我们',
	address: '新北市树林区备内街1巷35弄5号',
	phone: '0966-686-161 ／ 02-8687-2058',
	fax: '02-8687-2059',
	email: 'qingyi106@gmail.com'
};

export default locale;
